import Box from "@mui/material/Box";
import { Button, ButtonGroup } from "@mui/material";
import { Navigate, Outlet, redirect, useLocation, useNavigate } from "react-router-dom";
import { Pathtypesenum } from "./constants/data_arrays";


const App = () => {

    const location = useLocation()

    return (
        <Box sx={{
            padding: 1,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
        }}>
            {location.pathname === "/" && <Navigate to= {"/paths/"+Pathtypesenum[Pathtypesenum.Regular]} replace={true} />}
            <ButtonGroup sx={{justifyContent: "center", padding: 1}}>
                <Button  variant={ location.pathname.toLowerCase().includes("/paths") ? "contained" : "outlined" } href={"/paths"}> Paths </Button>
                <Button  variant={ location.pathname === "/models" ? "contained" : "outlined" } href={"/models"}> Models </Button>
                <Button  variant={ location.pathname === "/caps" ? "contained" : "outlined" } href={"/caps"}> Caps </Button>
            </ButtonGroup>
            <Outlet />

        </Box>
    );
};

export default App;
